import { esErrorApi } from '../api';

/**
 * Qué se le muestra a quien abre el contrato cuando no se pudo traer (KAN-184).
 *
 * Se decide sobre el **código**, nunca sobre el `detalle` (ver la regla en
 * `api/errores.ts`). Es una lectura: nada queda a medio hacer, así que los
 * mensajes pueden ser tranquilos y decir que se puede reintentar.
 */
export function mensajeDeContrato(error: unknown): string {
  if (!esErrorApi(error)) {
    return 'No se pudo traer el contrato. Probá de nuevo.';
  }
  switch (error.codigo) {
    case 'no_autenticado':
      return 'Tu sesión ya no vale. Volvé a entrar.';
    case 'sin_conexion':
      return 'No se pudo contactar al servicio. Esto solo consulta, así que podés reintentar sin riesgo.';
    case 'respuesta_ilegible':
      return 'El servicio devolvió un contrato que no se pudo leer. Avisale a quien lo administra.';
    case 'error_interno':
      return 'El servicio no pudo entregar el contrato. Probá de nuevo en un momento.';
    default:
      return 'No se pudo traer el contrato. Probá de nuevo.';
  }
}
